import React, { lazy, Suspense, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import Contacts from '../../components/container/contacts'
import Landing from '../../components/container/landing'
import Navbar from '../../components/container/navbar'
import Projects from '../../components/container/projects'
import About from '../../components/core-ui/about/about'
import Education from '../../components/core-ui/education/education'
import Experience from '../../components/core-ui/experience/experience'
import Skills from '../../components/core-ui/skills/skills'
import Glance from '../../components/core-ui/glance/glance'
import SectionErrorBoundary from '../../components/helper/error-boundary'
import SectionPlaceholder from '../../components/helper/section-placeholder'
import { headerData } from '../../data/headerData'

// Heavier, below-the-fold sections load as separate chunks so the first paint
// only pays for what is visible. They are prefetched once the page is idle.
const loadArchitecture = () => import('../../components/core-ui/architecture/architecture')
const loadSecurity = () => import('../../components/core-ui/security/security')
const loadCvLab = () => import('../../components/core-ui/cv-lab/cv-lab')
const loadRoleMatch = () => import('../../components/core-ui/role-match/role-match')

const Architecture = lazy(loadArchitecture)
const Security = lazy(loadSecurity)
const CvLab = lazy(loadCvLab)
const RoleMatch = lazy(loadRoleMatch)

function HomePage() {
    useEffect(() => {
        const prefetch = () => [loadRoleMatch, loadArchitecture, loadSecurity, loadCvLab].forEach((load) => load())
        if (typeof window.requestIdleCallback === 'function') {
            const id = window.requestIdleCallback(prefetch, { timeout: 4000 })
            return () => window.cancelIdleCallback(id)
        }
        const id = setTimeout(prefetch, 2500)
        return () => clearTimeout(id)
    }, [])

    return (
        <>
            <Helmet>
                <title>{`${headerData.name} | ${headerData.role}`}</title>
                <link rel='canonical' href='https://miretu.vercel.app/' />
            </Helmet>
            <Navbar />
            <main id='main'>
                <Landing />
                <Glance />
                <About />
                <Experience />
                <Skills />
                <SectionErrorBoundary id='match'>
                    <Suspense fallback={<SectionPlaceholder id='match' />}>
                        <RoleMatch />
                    </Suspense>
                </SectionErrorBoundary>
                <SectionErrorBoundary id='architecture'>
                    <Suspense fallback={<SectionPlaceholder id='architecture' />}>
                        <Architecture />
                    </Suspense>
                </SectionErrorBoundary>
                <SectionErrorBoundary id='security'>
                    <Suspense fallback={<SectionPlaceholder id='security' />}>
                        <Security />
                    </Suspense>
                </SectionErrorBoundary>
                <SectionErrorBoundary id='vision'>
                    <Suspense fallback={<SectionPlaceholder id='vision' />}>
                        <CvLab />
                    </Suspense>
                </SectionErrorBoundary>
                <Projects />
                <Education />
                <Contacts />
            </main>
        </>
    )
}

export default HomePage
